import { render, staticRenderFns } from "./passport-example.vue?vue&type=template&id=4f687e32&scoped=true&"
import script from "./passport-example.vue?vue&type=script&lang=js&"
export * from "./passport-example.vue?vue&type=script&lang=js&"
import style0 from "./passport-example.vue?vue&type=style&index=0&id=4f687e32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f687e32",
  null
  
)

export default component.exports